/** Astronomical unit in km (IAU 2012). */
export const AU_KM = 149_597_870.7;

/** Display unit: 1 du = 10⁶ km (decision D4). */
export const KM_PER_DU = 1e6;

/** Display units per AU in Realistic mode (exactly AU / 10⁶ km). */
export const AU_DU = AU_KM / KM_PER_DU;
